import { KalturaAssetListResponse } from '@kaltura-ott/ott-client-types/api/types';

import { KuxSelfServiceLink } from '../interfaces/self-service';

import { KalturaCategoryMetas, normalizeCategoryMetas } from './utils/meta';

/**
 * Parse self service lints to KuxSelfServiceLink
 * @param assetList
 */
export const parseSelfServiceLinks = (assetList: KalturaAssetListResponse): KuxSelfServiceLink[] => {
  const assets = assetList.objects;

  return (assets || []).map((asset) => {
    const metas = normalizeCategoryMetas(asset.metas as KalturaCategoryMetas);

    return {
      id: asset.id,
      name: asset.name,
      inAppLink: metas['in_app_link'] as string,
      link: metas['in_app_link'] as string,
      description: asset.description || '',
    };
  });
};
